import { QuoteType } from '@btcdirect/shared/src/composables/api/quote/types';
import { CurrencyPair } from '@btcdirect/stores';

export function isDisabled(currencyPair: CurrencyPair, quoteType?: QuoteType): boolean {
    if (!quoteType) {
        return currencyPair.buy.status === 'disabled' || currencyPair.sell.status === 'disabled';
    }

    return currencyPair[quoteType === 'c2f' ? 'sell' : 'buy'].status === 'disabled';
}
